import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { accentForCurrency } from 'utils/currency//currency-utils';
import { displayPriceSubUnit, priceFromInput, toSubUnit } from '../../../utils';
import EditorRow from '../EditorRow';

const ClearNumberArrows = styled.div`
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  input[type='number'] {
    -moz-appearance: textfield;
  }
`;

const StyledAdornment = styled(InputAdornment)`
  && {
    & > p {
      font-family: Basier Circle;
      font-size: 15px;
      color: #797979;
      padding-bottom: 2px;
    }
  }
`;

function PriceField(props) {
  const {
    id,
    className,
    value,
    onChange,
    disabled,
    hideLabel,
    labelAdornment,
    width,
    currency,
  } = props;

  const [rawPrice, setRawPrice] = useState(displayPriceSubUnit(value));

  let rawOnChange = e => {
    const price = priceFromInput(e.target.value);

    setRawPrice(price);
    onChange({ ...e, target: { ...e.target, value: toSubUnit(price) } });
  };

  return (
    <EditorRow className={className} width={width || 114}>
      <label htmlFor={id} style={{ display: hideLabel ? 'none' : '' }}>
        {labelAdornment}Gross Price (optional)
      </label>
      <ClearNumberArrows>
        <Input
          id={id}
          onChange={rawOnChange}
          value={rawPrice}
          placeholder="Gross Price"
          disabled={disabled}
          size="small"
          type="number"
          startAdornment={
            <StyledAdornment position="start">
              {accentForCurrency(currency)}
            </StyledAdornment>
          }
          inputProps={{ min: '0', step: '0.01' }}
          fullWidth={true}
          style={{ width: '70px' }}
        />
      </ClearNumberArrows>
    </EditorRow>
  );
}

PriceField.propTypes = {
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  hideLabel: PropTypes.bool,
};

PriceField.defaultProps = {
  disabled: false,
};

const mapStateToProps = state => {
  return {
    currency: state.venue.currency,
  };
};

export default connect(mapStateToProps)(PriceField);



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/MenuEditor/components/shared/PriceField/index.jsx